import api from "./apiClient";

/**
 * Portal POS API wrapper.
 * Assumes apiClient injects ucx_mfg_token Authorization header.
 */
const portalPosApi = {
  // Branch list (POS-friendly)
  async listBranches() {
    const res = await api.get("/api/pos/branches");
    return res.data; // { ok, branches }
  },

  async listTerminals(branchId) {
    const res = await api.get("/api/pos/terminals", { params: { branchId } });
    return res.data; // { ok, terminals }
  },

  async getOpenShift({ branchId, terminalId }) {
    const res = await api.get("/api/pos/shifts/open", { params: { branchId, terminalId } });
    return res.data; // { ok, shift }
  },

  async openShift({ branchId, terminalId, openingNote }) {
    const res = await api.post("/api/pos/shifts/open", { branchId, terminalId, openingNote });
    return res.data; // { ok, shift }
  },

  async closeShift(shiftId, { closingNote }) {
    const res = await api.post(`/api/pos/shifts/${shiftId}/close`, { closingNote });
    return res.data; // { ok, shift }
  },

  async getShiftSummary(shiftId) {
    const res = await api.get(`/api/pos/shifts/${shiftId}/summary`);
    return res.data; // { ok, summary }
  },

  // Frontend/src/unicodex_ui/services/portalPosApi.js

  // Barcode resolve hook (POS scan)
  async resolveByBarcode({ branchId, value }) {
    const res = await api.get("/api/identity/products/resolve-by-barcode", {
      params: { branchId, value, posOnly: 1 },
    });
    return res.data; // { ok, product } or { ok, not_found: true }
  },

  // Option A product search
  async searchProducts({ branchId, search = "", limit = 20, offset = 0 }) {
    const res = await api.get("/api/identity/products", {
      params: { branchId, search, limit, offset, posOnly: 1 },
    });
    const data = res.data || {};
    // Backend returns { ok, products, total } (identity.routes.js).
    // Normalize for POS page which expects { items }.
    const itemsRaw = Array.isArray(data.products)
      ? data.products
      : Array.isArray(data.items)
        ? data.items
        : [];

    const items = itemsRaw.map((p) => ({
      ...p,
      // expose camelCase for UI
      unitPrice:
        p?.unitPrice !== undefined && p?.unitPrice !== null
          ? Number(p.unitPrice)
          : p?.unit_price !== undefined && p?.unit_price !== null
            ? Number(p.unit_price)
            : 0,
      taxRate:
        p?.taxRate !== undefined && p?.taxRate !== null
          ? Number(p.taxRate)
          : p?.tax_rate !== undefined && p?.tax_rate !== null
            ? Number(p.tax_rate)
            : 0,
    }));
    return {
      ...data,
      items,
    };
  },

  // Stock check endpoint requested
  async stockCheck({ branchId, productId, batchId, quantity }) {
    const res = await api.get("/api/pos/stock/check", {
      params: { branchId, productId, batchId, quantity },
    });
    return res.data; // { ok, available, allowed, warning?, locationId? }
  },

  async createSale(payload) {
    const res = await api.post("/api/pos/sales", payload);
    return res.data; // { ok, sale }
  },

  async listSales(params) {
    const res = await api.get("/api/pos/sales", { params });
    return res.data; // { ok, sales, total? ... }
  },

  // For receipts (supervisor filters)
  async listSalesForReceipt(params) {
    // same endpoint; separate wrapper to keep POS page clean
    const res = await api.get("/api/pos/sales", { params });
    return res.data;
  },

  async getSale(id) {
    const res = await api.get(`/api/pos/sales/${id}`);
    return res.data; // { ok, sale }
  },

  async voidSale(id, reason) {
    const res = await api.post(`/api/pos/sales/${id}/void`, { reason });
    return res.data;
  },

  async refundSale(id, reason) {
    const res = await api.post(`/api/pos/sales/${id}/refund`, { reason });
    return res.data;
  },
};

export default portalPosApi;
